import httpUtil from '../utils/httpUtil'


/**
 * 密码登录
 * type : 是否显示loading
 */
 export function fetchLoginByPhone(params,type) {
	return httpUtil.post("/api/crmPc/home/crmPcLoginByPhone", params,type)
}

/**
 * 邮箱登录
 * type : 是否显示loading
 */
 export function fetchLoginByEmail(params,type) {
	return httpUtil.post("/api/crmPc/home/crmPcLoginByEmail", params,type)
}

/**
 * 验证码登录（手机号或邮箱）
 * type : 是否显示loading
 */
export function fetchLoginByCode(params,type) {
	return httpUtil.post("/api/crmPc/home/crmPcLoginByCode", params,type)
}


/**
 * 获取验证码
 */
export function fetchPhoneVeriCode(params,type) {
	return httpUtil.post("/api/crmPc/home/sendSms", params , type)
}

export function fetchEmailVeriCode(params,type) {
	return httpUtil.post("/api/crmPc/home/sendEmailCode", params , type)
}

/**
 * 查询公司
 */
export function fetchCompanyByPhone(params,type) {
	const url = "/api/crmPc/home/getCompanyListByPhone"
	return httpUtil.post(url, params, type)
}

/**
 * 查询公司
 */
export function fetchCompanyByEmail(params,type) {
	const url = "/api/crmPc/home/getCompanyListByEmail"
	return httpUtil.post(url, params, type)
}


/**
 * 获取登录code码
 */
 export function fetchCodeUrl(params,type) {
	return httpUtil.post("/api/crmPc/home/getPcLoginImg", params, type)
}

/**
 * 扫码成功后回调码
 */
 export function pcLoginCallBack(params,type) {
	return httpUtil.post("/api/crmPc/home/pcLoginCallBack", params, type)
}

/**
 * 图形验证码
 */
 export function getVerifiCode(params,type) {
	return httpUtil.post("/api/crmPc/home/getVerifiCode", params, type)
}

/**
 * 获取认证签名
 */
 export function forgetPwd(params,type) {
	return httpUtil.post("/api/crmPc/home/forgetPwd", params, type)
}


/**
 * 修改密码
 */
 export function updatePwd(params,type) {
	return httpUtil.post("/api/crmPc/home/updatePwd", params, type)
}

/**
 * 检查验证码是否正确
 */
export function checkSms(params,type) {
	return httpUtil.post("/api/crmPc/home/checkSms", params, type)
}

export function checkEmailCode(params,type) {
	return httpUtil.post("/api/crmPc/home/checkEmailCode", params, type)
}


/**
 * 按密码修改密码
 */
 export function modifyPwd(params,type) {
	return httpUtil.post("/api/crmPc/home/modifyPwd", params, type)
}




export default {
	fetchPhoneVeriCode,
	fetchCompanyByPhone,
	fetchCompanyByEmail,
	fetchCodeUrl,
	pcLoginCallBack,
	getVerifiCode,
	forgetPwd,
	updatePwd,
	fetchLoginByPhone,
	fetchLoginByEmail,
	fetchLoginByCode,
	checkSms,
	checkEmailCode,
	modifyPwd,
	fetchEmailVeriCode
}